if (!customElements.get('footer-accordion-mto')) {
  customElements.define(
    'footer-accordion-mto',
    class FooterAccordionMto extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.footer-accordion-mto__toggle');
        if (!this.toggle) return;
        this.toggle.addEventListener('click', () => {
          // desktop keeps the menu always open
          if (window.matchMedia('(min-width: 750px)').matches) return;
          const isOpen = this.classList.toggle('is-open');
          this.toggle.setAttribute('aria-expanded', isOpen);
        });
      }
    }
  );
}
